<script lang="ts">
	import { AppLocale, getLocaleFlag } from '#lib/helper/locale.js';
	import { selectedLocale } from '#lib/stores/i18n.js';

	let isOpen = $state(false);
	let container: HTMLElement | undefined = $state(undefined);

	function toggle(event: MouseEvent) {
		event.stopPropagation();
		isOpen = !isOpen;
	}

	function select(locale: AppLocale) {
		$selectedLocale = locale;
		isOpen = false;
	}

	function close(event: MouseEvent) {
		if (isOpen && container && !container.contains(event.target as Node)) {
			isOpen = false;
		}
	}
</script>

<svelte:window onclick={close} />

<div bind:this={container} class="relative flex items-center">
	<button
		onclick={toggle}
		class="flex items-center justify-center px-2 py-1 rounded-full hover:bg-black/5 dark:hover:bg-white/10 transition-colors"
		aria-label="Change language"
	>
		<span
			class="text-lg leading-none filter grayscale transition-all hover:grayscale-0"
			class:grayscale-0={isOpen}
		>
			{getLocaleFlag($selectedLocale)}
		</span>
	</button>

	{#if isOpen}
		<div
			class="absolute bottom-full mb-2 left-1/2 -translate-x-1/2
                   bg-white dark:bg-zinc-800
                   shadow-xl rounded-lg border border-gray-100 dark:border-zinc-700
                   py-1 flex flex-col items-center z-50 overflow-hidden min-w-[3rem]"
		>
			{#each Object.values(AppLocale) as locale}
				<button
					class="w-full px-3 py-2 hover:bg-gray-50 dark:hover:bg-zinc-700/50
                           transition-colors flex items-center justify-center
                           {locale === $selectedLocale ? 'bg-blue-50 dark:bg-blue-900/10' : ''}"
					onclick={() => select(locale)}
				>
					<span class="text-xl leading-none">{getLocaleFlag(locale)}</span>
				</button>
			{/each}
		</div>
	{/if}
</div>
